import { Container, Section } from '@flos/react-ui';
import { track } from 'c9-tracking';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import './App.scss';
import Area from './components/Area';
import Receipt from './components/Receipt';
import './polyfill.scss';
import { IState } from './types';

const App = () => {
  useEffect(() => {
    track.ready(true);
  }, []);

  const submitted = useSelector<IState, boolean>((state) => state.navigation.submission.done);

  return (
    <Section className="Section">
      <Container>
        {!submitted && <Area />}
        {submitted && <Receipt />}
      </Container>
    </Section>
  );
};

export default App;
